import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { UtilsService } from 'src/app/utils/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CycloneDataService } from './cyclone-data.service';
import { CycloneConstants } from './cyclone.constant';
import { isNull, isNullOrUndefined } from 'util';

@Component({
  selector: 'app-cyclone',
  templateUrl: './cyclone.component.html',
  styleUrls: ['./cyclone.component.scss']
})
export class CycloneComponent implements OnInit, OnDestroy, OnChanges {

  @Input() labelStrings: any;
  @Input() selectedIcon: any;
  @Input() fullScreenView: any;
  @Input() fullScreenMapName: any;
  @Input() isSideMenuOpenMobile:boolean;
  buttonClickedArray: any;
  selectedWindSpeed: any;
  selectedHumidity: any;
  selectedRainfall: any;
  selectedTemperature: any;
  forecastLengthSubscription: any;
  blockArraySubscription: any;
  sixHourBlocks: any;
  selected: string;
  selectedBlock: any;
  adminSelected: any = true;
  forecastLength: any;
  imdSRLR: any;
  disableSRLRToggle: any;
  stateUrlId: any;
  timeStampList: {};
  detEnsmbl: string;
  // gfsEcmwf: string;
  checkedList = {
    'cloud cover': false,
    'cloud top temperature': false,
    radar: false,
    'wave height': false,
    'storm surge': false
  };
  selectedEvent = '';
  events = [
    { key: 'Current event', val: ''},
    { key: 'Last 10 events', val: '10' },
    { key: 'Last 50 events', val: '50' }
  ];
  selectedDate = '';
  dates: any = [];
  showDates: any = true;
  gfsEcmwf: any = 'ECMWF';
  sourceDropdown = [
    { key: 'ECMWF', val: 'ECMWF' },
    { key: 'IMD', val: 'IMD' }
    // { key: 'GFS', val: 'NOAA' }
  ];
  favouriteMaps: any;
  favouriteMapsSubscription: any;
  disabledMapsList = [];
  favouriteMapsOrder = [];
  favouriteMapsOrderSubscription: any;
  layerChecked = true;
  layerAddCheckSubscription: any;
  cycloneNamesArray = [];
  activeCycloneArray = [];
  forecastTypeAry = [];
  forecastTypeArySubscription: any;
  cycloneLayersObject = {};
  cycloneConstants: any;
  expandLayers = false;
  waveDEMLayers = [];
  waveDEMLayersSubscription: any;
  disabledDEmLayers = [];
  deviceType: string;

  constructor(private utils: UtilsService, private router: Router, private route: ActivatedRoute, private service: CycloneDataService) {
    for (const key in ProjConstants.IDTOUUIDMAPPING) {
      if (!ProjConstants.IDTOUUIDMAPPING.hasOwnProperty(this.route.snapshot.paramMap.get('id'))) {
        router.navigate(['*']);
      }
    }
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
    ProjConstants.STATENAME = this.utils.getStateName(this.stateUrlId);

    this.imdSRLR = false;
    this.disableSRLRToggle = false;

    const temp = this.utils.getAdminBasinToggle().subscribe(
      data => {
        this.adminSelected = data;
      });
    temp.unsubscribe();
    const temp1 = this.utils.getSourceToggle().subscribe(
      data => {
        this.gfsEcmwf = data;
    });
    temp1.unsubscribe();
    this.utils.setSRLRToggle(this.imdSRLR);

    this.buttonClickedArray = [true, false, false, false];
    this.selectedWindSpeed = true;
    this.selectedHumidity = false;
    this.selectedRainfall = false;
    this.selectedTemperature = false;

    this.forecastLengthSubscription = this.utils.getForecastLengthChanged().subscribe(value => {

      this.forecastLength = value;
      if (this.forecastLength != null) {
      }
      if (this.forecastLength == '10') {
        this.disableSRLRToggle = true;

        this.imdSRLR = false;
      } else {
        this.disableSRLRToggle = false;
        this.imdSRLR = true;
      }
    });
    this.cycloneConstants = CycloneConstants;
  }

  ngOnInit() {
    // mobile
    this.deviceType = this.utils.getDeviceType();
    // setTimeout(function() {
    //   window.location.reload();
    // }, 900000);
    this.forecastLength = this.route.snapshot.paramMap.get('time');
    // this.createlabelStrings();
    const url = this.router.url;
    const urlparams = url.split('/', 10);
    this.selected = urlparams[2];
    this.sixHourBlocks = ProjConstants.SIXHOURBLOCKS;
    this.utils.getDeterministicOrEnsemble().subscribe((value: string) => {
      this.detEnsmbl = value;
    });
    this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
      this.sixHourBlocks = value;
    });
    this.favouriteMapsSubscription = this.utils.getFavouriteMaps().subscribe((data: any) => {
      this.favouriteMaps = data;
      this.returnCheckedValue();
    });
    this.favouriteMapsOrderSubscription = this.utils.getFavouriteMapsOrder().subscribe((data: any) => {
      this.favouriteMapsOrder = data;
    });
    this.layerAddCheckSubscription = this.utils.getWindLayerAdd().subscribe(value => {
      this.layerChecked = value;
    });
    this.utils.cycloneLayersObject.subscribe(data => this.cycloneLayersObject = data);
    this.utils.getCycloneNamesArray().subscribe(data => this.cycloneNamesArray = data);
    this.utils.getActiveCycloneArray().subscribe(data => this.activeCycloneArray = data);
    this.forecastTypeArySubscription = this.utils.getCycloneForecastTypeArray().subscribe(data => {
      this.forecastTypeAry = [...data];
    });
    this.utils.getCycloneEvent().subscribe((value: string) => {
      if (value !== '') {
        this.geteventdates(value);
      }
    }).unsubscribe();
    this.waveDEMLayersSubscription = this.utils.getWaveDEMLayersList().subscribe((data: object[]) => {
      this.waveDEMLayers = data;
    });
  }

  ngOnDestroy() {
    if(!isNullOrUndefined(this.forecastLengthSubscription)) {
      this.forecastLengthSubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.blockArraySubscription)){
      this.blockArraySubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.favouriteMapsSubscription)) {
      this.favouriteMapsSubscription.unsubscribe();
    } if(!isNullOrUndefined(this.favouriteMapsOrderSubscription)) {
      this.favouriteMapsOrderSubscription.unsubscribe();
    }
    if(!isNullOrUndefined(this.waveDEMLayersSubscription)) {
      this.waveDEMLayersSubscription.unsubscribe();
    }
  }

  ngOnChanges() {
  }

  showLayer(blockNumber) {
    this.blockArraySubscription = this.utils.getBlocksArray().subscribe(value => {
      this.sixHourBlocks = value;
      this.utils.setIndex(this.labelStrings[blockNumber].groupName);
      this.utils.getSRLRToggle().subscribe(value => {
        if (value === true) {
          this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING[blockNumber.toString()]);
        } else {
          this.utils.setTimestamp(ProjConstants.INDEX_TO_TIMESTAMP_MAPPING_LR[blockNumber.toString()]);
        }
      });
    });
  }

  adminBasinToggle() {
    this.adminSelected = !this.adminSelected;
    this.utils.setAdminBasinToggle(this.adminSelected);
  }

  buttonClicked(index) {
    // if (from === 'HTML') {
    //   this.posNum.emit(index);
    // }
    this.showLayer(index);
  }

  shortRangeLongRangeToggle() {
    this.imdSRLR = !this.imdSRLR;
    this.utils.setSRLRToggle(this.imdSRLR);
  }

  createlabelStrings() {
    if (this.forecastLength == '24') {
      this.timeStampList = this.utils.get24HrsTimeStamps();
      for (const index in this.timeStampList) {
        if (index == '4') {
          this.labelStrings[index] = { label: '24hr', groupName: '24hr' };
        } else {
          this.labelStrings[index] = { label: this.convertTimestampToBlockValue(this.timeStampList[index]).toString(), groupName: this.timeStampList[index].toString() };
        }
      }
    } else if (this.forecastLength == '10') {
      this.timeStampList = this.utils.get10DaysTimeStamps();
      for (const index in this.timeStampList) {
        this.labelStrings[index] = { label: this.convertTimestampToBlockValue(this.timeStampList[index]).toString(), groupName: this.timeStampList[index].toString() };
      }
    }
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    if (this.forecastLength == '24') {
      let starthours = new Date(ts).getHours();
      const startminutes = new Date(ts).getMinutes();
      let startamPm = 'A.M';
      if (starthours > 12) {
        starthours = starthours - 12;
        startamPm = 'P.M';
      }
      let endhours = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getHours();
      const endminutes = new Date(ts + ProjConstants.MILLIS_IN_6HOURS).getMinutes();
      let endamPm = 'A.M';
      if (endhours > 12) {
        endhours = endhours - 12;
        endamPm = 'P.M';
      }
      return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
    } else if (this.forecastLength == '10') {
      const date = new Date(ts).toLocaleDateString();
      return date;
    } else {
      return ts;
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i].fullLabel;
    }
  }

  detEnsmblToggle(type: string) {
    if (type !== this.detEnsmbl) {
      this.detEnsmbl = type;
      this.utils.setDetermisnisticOrEnsemble(this.detEnsmbl);
    }
  }

  imdEcmwfToggle(type: string) {
    this.gfsEcmwf = type;
    this.utils.setSourceToggle(this.gfsEcmwf);
  }

  geteventdates(event: string) {
    setTimeout(() => {
      this.utils.setCycloneEvent(event);
    }, 500);
    if (event === '') {
      this.showDates = true;
      this.selectedDate = event;
      this.utils.setcycloneDates(this.selectedDate);
    } else {
      this.selectedEvent = event;
      this.showDates = true;
      this.utils.getcycloneDates().subscribe(value => {
        if (!isNull(value)) {
          this.selectedDate = value;
        } else {
          this.selectedDate = '';
        }
      }).unsubscribe();
      // this.selectedDate = '';
      let dates;
      this.dates = [];
      this.service.getHistoricalData(this.selectedEvent).subscribe(data => {
        if (data) {
          Object.values(data).forEach(value => {
            if (value) {
              dates = [];
              dates = value;
              dates.sort((a,b) => a < b ? 1 : -1);
              // dates.sort();
              dates.forEach(value => {
                const obj = { key: this.getdatehere(value), val: value};
                this.dates.push(obj);
              });
              this.showDates = false;
            }
          });
        }
      });
    }
  }

  getdates(date) {
    this.selectedDate = date;
    this.utils.setcycloneDates(this.selectedDate);
  }

  getdatehere(date) {
    if (date != null && date != undefined) {
      const d = date[6] + date[7] + '-' + date[4] + date[5] + '-' + date[0] + date[1] + date[2] + date[3];
      return d;
    }
  }

  returnCheckedValue() {
    Object.keys(this.checkedList).forEach((key: any) => {
      this.checkedList[key] = false;
    });
    Object.keys(this.favouriteMaps).forEach((key: any) => {
      if (this.checkedList[this.favouriteMaps[key]] === false) {
        this.checkedList[this.favouriteMaps[key]] = true;
      }
    });
    this.updateDisabledMapList();
  }

  changeFavouriteMaps(mapName: string) {
    this.checkedList[mapName] = !this.checkedList[mapName];
    this.utils.setFavouriteMapName(mapName);
  }

  updateDisabledMapList() {
    let count = 0;
    Object.keys(this.checkedList).forEach((key) => {
      if (this.checkedList[key] === true) {
        count++;
      }
    });
    if (count === 3) {
      Object.keys(this.checkedList).forEach((key: any) => {
        if (this.checkedList[key] === false) {
          this.disabledMapsList.push(key);
        }
      });
    } else {
      this.disabledMapsList = [];
    }
    this.utils.disabledMaps.next(this.disabledMapsList);
  }

  checkIfListIncludes(name: string, list: any[]) {
    return (list.includes(name));
  }

  toggleLayer(event: any) {
    this.layerChecked = event;
    this.utils.setWindLayerAdd(event);
  }

  changeActiveCycloneList(name: string) {
    if (this.checkIfListIncludes(name, this.activeCycloneArray)) {
      this.activeCycloneArray.splice(this.activeCycloneArray.indexOf(name), 1);
    } else {
      this.activeCycloneArray = [];
      this.activeCycloneArray.push(name);
    }
    this.utils.setActiveCycloneArray(this.activeCycloneArray);
  }

  changeForecastTypeArray(type: string) {
    if (this.checkIfListIncludes(type, this.forecastTypeAry)) {
      this.forecastTypeAry.splice(this.forecastTypeAry.indexOf(type), 1);
    } else {
      this.forecastTypeAry.push(type);
    }
    this.utils.setCycloneForecastTypeArray(this.forecastTypeAry);
  }

  clickToToggleExpand() {
    this.expandLayers = !this.expandLayers;
  }

  updateDisabledDEMLayer(layerName: string) {
    if (!this.disabledDEmLayers.includes(layerName)) {
      this.disabledDEmLayers.push(layerName);
      this.waveDEMLayers.forEach(layer => {
        if (layer['layerName'] === layerName) {
          layer['visible'] = false;
        }
      });
    } else {
      this.disabledDEmLayers.forEach((layername, index) => {
        if (layername === layerName) {
          this.disabledDEmLayers.splice(index, 1);
        }
      });
      this.waveDEMLayers.forEach(layer => {
        if (layer['layerName'] === layerName) {
          layer['visible'] = true;
        }
      });
    }
    this.utils.disabledDEMLayersList.next(this.disabledDEmLayers);
  }
}
